import { MenuItem, Select } from "@material-ui/core";
import React, { Component } from "react";
import styled from "styled-components";
import { LibraryView } from "common/constants";
import { ActionPermissionsObject, PermissionActionType, WorkspacePlanTier } from "common/interfaces";
import WorkspaceController from "js/controllers/WorkspaceController";
import { app } from "js/namespaces";
import UpgradeIcon from "js/Components/UpgradeIcon";
import { FlexBox } from "js/react/components/LayoutGrid";
import { Divider } from "js/react/components/UiComponents";
import { t } from "js/i18n";

const MyPresentationsTitle = styled.div`
    padding: 10px;
    font-size: 16px;
    color: #000;
    border: none;
    cursor: pointer;
    background: transparent;
    font-weight: 600;
    font-family: "Source Sans Pro";
    text-transform: uppercase;
`;

export class PresentationLibraryViewSelect extends Component {
    render() {
        const { libraryView, onSwitchType, isMyPresentationsOnly } = this.props;

        const isBasic = WorkspaceController.plan.tier === WorkspacePlanTier.BASIC;
        const canCreateResources = !app.integrator && WorkspaceController.actionPermissions[ActionPermissionsObject.RESOURCES].create;
        const canUpgradeToCreateResources = !app.integrator && (isBasic || WorkspaceController.canUpgradeToRemoveActionRestriction(ActionPermissionsObject.RESOURCES, PermissionActionType.CREATE));
        const canManageSharedSlides = !app.integrator && WorkspaceController.actionPermissions[ActionPermissionsObject.SHARED_RESOURCES].manage;
        const canUpgradeToManageSharedSlides = !app.integrator && WorkspaceController.canUpgradeToRemoveActionRestriction(ActionPermissionsObject.SHARED_RESOURCES, PermissionActionType.MANAGE);
        const canUpgradeToUseSharedResources = WorkspaceController.canUpgradeToRemoveActionRestriction(ActionPermissionsObject.SHARED_RESOURCES, "use");

        //can be removed when create ability is removed for basic
        const shouldShowMyResourcesUpgradeState = !app.integrator && (canUpgradeToCreateResources || isBasic);
        const shouldShowTeamResourcesUpgradeState = !app.integrator && (canUpgradeToManageSharedSlides || canUpgradeToUseSharedResources);

        return (
            <>
                {isMyPresentationsOnly ? (
                    <MyPresentationsTitle>{t("My Presentations")}</MyPresentationsTitle>
                ) : (
                    <Select
                        id="libraryType"
                        value={libraryView}
                        onChange={event => onSwitchType(event.target.value)}
                        disableUnderline
                        renderValue={value => {
                            if (value === LibraryView.TEAM_RESOURCES) {
                                return (
                                    <FlexBox left>
                                        {shouldShowTeamResourcesUpgradeState && (
                                            <UpgradeIcon style={{ marginRight: 8 }} />
                                        )}
                                        {t("Team Resources")}
                                    </FlexBox>
                                );
                            } else if (value === LibraryView.MY_RESOURCES) {
                                return (
                                    <FlexBox left>
                                        {shouldShowMyResourcesUpgradeState && (
                                            <UpgradeIcon style={{ marginRight: 8 }} />
                                        )}
                                        {t("My Resources")}
                                    </FlexBox>
                                );
                            }

                            return t("My Presentations");
                        }}
                    >
                        <MenuItem value={LibraryView.LIBRARY}>{t("My Presentations")}</MenuItem>
                        {(canCreateResources || shouldShowMyResourcesUpgradeState) && (
                            <MenuItem value={LibraryView.MY_RESOURCES}>
                                {t("My Resources")}
                                {shouldShowMyResourcesUpgradeState && (
                                    <UpgradeIcon style={{ marginLeft: "auto" }} />
                                )}
                            </MenuItem>
                        )}
                        {(canManageSharedSlides || shouldShowTeamResourcesUpgradeState) && (
                            <MenuItem value={LibraryView.TEAM_RESOURCES}>
                                {t("Team Resources")}
                                {shouldShowTeamResourcesUpgradeState && (
                                    <UpgradeIcon style={{ marginLeft: "auto" }} />
                                )}
                            </MenuItem>
                        )}
                    </Select>
                )}
                <Divider margin={10} />
            </>
        );
    }
}

export default PresentationLibraryViewSelect;
